<template>
    <article class='xbed-oms-content'>
        <section class='xbed-sub-title'>
            <span>外部房源订单</span>
        </section>
        <section style='marginTop:20px'>
            <Form :model='formList' ref='formList'>
                <Row>
                    <Col span='5'>
                        <FormItem prop='' label='创建日期' :label-width='120'>
                            <date-picker type='daterange' :model='formList.datePick' :value='formList.datePick' @on-change="datepick"  style='width:100%'></date-picker>
                        </FormItem>
                    </Col>
                    <Col span='5'>
                        <FormItem prop='' label='完成时间' :label-width='120'>
                            <date-picker type='daterange' :model='formList.finishPick' :value='formList.finishPick' @on-change="finishPick"  style='width:100%'></date-picker>
                        </FormItem>
                    </Col>
                    <Col span='5'>
                        <FormItem prop='' label='订单状态' :label-width='120'>
                            <Select v-model='formList.orderStatus'>
                                <Option v-for='status in orderStatus' :key='status.id' :value='status.id'>{{status.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span='5'>
                        <FormItem prop='' label='支付状态' :label-width='120'>
                            <Select v-model='formList.payStatus'>
                                <Option v-for='status in payStatus' :key='status.id' :value='status.id'>{{status.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="5">
                         <FormItem prop='' label='Xbed订单号' :label-width='120' >
                            <Input type='text' v-model='formList.xbedOrder'></Input>
                        </FormItem>
                    </Col>
                    <Col span="5">
                         <FormItem prop='' label='艺龙订单号' :label-width='120' >
                            <Input type='text' v-model='formList.elongOrder'></Input>
                        </FormItem>
                    </Col>
                    <Col span="5">
                         <FormItem prop='' label='手机号' :label-width='120' >
                            <Input type='text' v-model='formList.phone'></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="5">
                         <FormItem prop='' label='姓名' :label-width='120' >
                            <Input type='text' v-model='formList.name'></Input>
                        </FormItem>
                    </Col>
                    <Col span='3' offset="2">
                        <FormItem>
                            <Button type='primary' @click='queryOrderList'>查询</Button>
                        </FormItem>
                    </Col>
                    <Col span='3' v-if='isShowExportBtn'>
                        <FormItem>
                            <Button type='primary' @click='getOrderList'>导出筛选结果</Button>
                        </FormItem>
                    </Col>
                </Row>
                <Table stripe :loading='orderListLoading' :width="tableWidth" height="550" :columns="orderList" :data="orderListData.list">
                </Table>
                <div style="margin: 10px;overflow: hidden">
                    <Page show-sizer placement="top" :total="orderListData.total" :current="formList.page" :page-size="formList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
                </div>
            </Form>
        </section>
       
    </article>
</template>
<script>
import Moment from 'moment';
// import {phoneRegular} from "../../utils/regular"
import API from "../../api";
import Utils from '../../utils';

export default{
    created(){
        this.token = Utils.findFromLocalStorage('vue-token');
        this.env = Utils.findFromLocalStorage('env','dev');
        this.userId = Utils.findFromLocalStorage('vue-userid');
        this.tableWidth = window.screen.width - 235;
        if(!Utils.hasPermission('Elong_elongRoomSourceOrderList_Export')){
            this.isShowExportBtn = false;
        }
    },
    data(){
        return {
            isShowExportBtn: true,
            tableWidth: 0,
            orderStatus:[
                {
                    name:'全部',
                    id:99
                },
                {
                    name:'待支付',
                    id:0
                },
                {
                    name:'待入住',
                    id:1
                },
                {
                    name:'已入住',
                    id:4
                },
                {
                    name:'已完成',
                    id:2
                },
                {
                    name:'已取消',
                    id:3
                }
            ],
            payStatus:[
                {
                    name:'全部',
                    id:99
                },
                {
                    name:'未支付',
                    id:0
                },
                {
                    name:'已支付',
                    id:1
                },
                {
                    name:'待退款',
                    id:2
                },
                {
                    name:'已退款',
                    id:3
                },
                {
                    name:'支付失败',
                    id:4
                },
            ],
            formList:{
                orderStatus: 99,
                payStatus: 99,
                startDate: '',
                endDate: '',
                xbedOrder: '',
                elongOrder:'',
                phone: '',
                name: '',
                page: 1,
                pageSize: 10,
                datePick:[Moment().subtract(29, 'days').format('YYYY-MM-DD'), Moment().format('YYYY-MM-DD')],
                finishPick:['', '']
            },
            // ruleValidate: {
            //     phone:[
            //         { type: "string", pattern: phoneRegular, message: "请填写正确的手机号码" }
            //     ]
            // },
            orderListLoading:false,
            orderListData:[

            ],
            orderList:[
                {
                    title:'艺龙订单号',
                    key:'outOrderId', //  outOrderId 艺龙订单号
                    minWidth:150,
                    align: 'center',
                    render: (h,params)=>{
                        return h("div", {
                            style:{
                                'color':'#2d8cf0'
                            },
                            on:{
                                click:()=>{
                                    if(this.$router){
                                        this.$router.push({
                                        path: "/app/elong/orderDetail",
                                        query: { 
                                            orderId: params.row.orderId,
                                            }
                                        });
                                    }else{
                                        //  orderId xbed订单号
                                        window.open(`#/Elong/Elong/elongOrderDetail?orderId=${params.row.orderId}`);
                                    }
                                    
                                }
                            }
                        }, params.row.outOrderId);
                    }
                },
                {
                    title:'xbed订单号',
                    key:'orderId', //  orderId xbed订单号
                    minWidth:150,
                    align: 'center',
                    // render: (h,params)=>{
                    //     return h("div", {
                    //         style:{
                    //             'color':'#2d8cf0'
                    //         },
                    //         on:{
                    //             click:()=>{
                    //                 if(this.$router){
                    //                     this.$router.push({
                    //                     path: "/app/elong/orderDetail",
                    //                     query: { 
                    //                         orderId: params.row.orderId,
                    //                         }
                    //                     });
                    //                 }else{
                    //                     //  orderId xbed订单号
                    //                     window.open(`#/Elong/Elong/elongOrderDetail?orderId=${params.row.orderId}`);
                    //                 }
                                    
                    //             }
                    //         }
                    //     }, params.row.orderId);
                    // }
                },
                {
                    title:'创建时间',
                    key:'ctime',
                    minWidth:150,
                    align: 'center',
                    render:(h,params)=>{
                        let time = Moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss');
                        return h('div',{}, time);
                    }
                },
                {
                    title:'下单人',
                    key:'creator',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'入住人',
                    key:'roomOfPersion',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'预订渠道',
                    key:'sourceType',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'订单状态',
                    key:'status',
                    minWidth:150,
                    align: 'center',
                    render: (h,params)=>{
                        let orderStatus = ['待支付','待入住','已完成','已取消','已入住'][params.row.status];
                        return h('div',{},orderStatus)
                    }
                },
                {
                    title:'支付状态',
                    key:'payStatus',
                    minWidth:150,
                    align: 'center',
                    render: (h,params)=>{
                        let pay = ['未支付','已支付','待退款','已退款','支付失败'][params.row.payStatus];
                        return h('div',{}, pay)
                    }
                },
                {
                    title:'预计入住日期',
                    key:'arrivalDate',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'预计退房日期',
                    key:'departureDate',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'房源',
                    key:'',
                    minWidth:150,
                    align: 'center',
                    render:(h)=>{
                        return h('div',{},'艺龙')
                    }
                },
                {
                    title:'门店',
                    key:'hotelName',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'房型产品',
                    key:'roomName',
                    minWidth:150,
                    align: 'center',
                },{
                    title:'房数',
                    key:'numOfRooms',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'备注',
                    key:'remark',
                    minWidth:150,
                    align: 'center',
                }
            ]
        }
    },
    async mounted() {
        this.formList.loading = true;
        let params = this.initAjaxParams();
        let respData = (await API.omsAPI[this.env].elong.queryOrderList(params,this.token)).data;
        this.orderListData = respData.data;
        // this.formList.page++;
        this.formList.loading = false;
    },
    methods:{
        datepick(dataArr){
            this.formList.datePick = dataArr;
        },
        finishPick(dataArr){
            this.formList.finishPick = dataArr;
        },
        async changePage(pageIndex) {
            this.formList.page = pageIndex;
            this.formList.loading = true;
            let params = this.initAjaxParams();
            let respData = (await API.omsAPI[this.env].elong.queryOrderList(params,this.token)).data;
            this.orderListData = respData.data;
            this.formList.loading = false;
        },
        changePageSize(pageSize){
            this.formList.page = 1;
            this.formList.pageSize = pageSize;
        },
        async queryOrderList(){
            this.formList.page = 1;
            this.formList.loading = true;
            let params = this.initAjaxParams();
            let respData = (await API.omsAPI[this.env].elong.queryOrderList(params,this.token)).data;
            this.orderListData = respData.data;
            this.formList.loading = false;
        },
        async getOrderList(){

           
            let params = this.initAjaxParams();
            let gatewayUrl = API.omsAPI[this.env].elong.gatewayClient.gatewayUrl;
            let url = `${gatewayUrl}api/v1/elong/oms/order-export?pageNum=${params.page_num || ''}&pageSize=${params.page_size || ''}&payStatus=${params.pay_status != undefined ? params.pay_status : ''}&startDate=${params.start_date || ''}&endDate=${params.end_date || ''}&mobile=${params.mobile || ''}&name=${params.name || ''}&outOrderId=${params.out_order_id != undefined ? params.out_order_id : ''}&orderId=${params.order_id != undefined ? params.order_id : ''}&status=${params.status != undefined ? params.status : ''}&finishStartDate=${params.finish_start_date || ''}&finishEndDate=${params.finish_end_date || ''}`
            console.info(url)
            window.open(url)
            // let respData = (await API.omsAPI[this.env].elong.downloadList(params,this.token));
            // console.info(respData)
            // let blob = new Blob([respData.data])
            // console.info(blob)
            // let a = document.createElement('a');
            // a.download = '外部房源订单列表.xls';
            // a.href = window.URL.createObjectURL(blob);
            // document.body.append(a);
            // a.click();
            // a.remove();
            // let title = respData.retCode == 200 ? '导出成功' : '导出失败';
            // this.$Notice.info({
            //     title: title,
            //     desc: respData.msg
            // });
        },
        initAjaxParams(){
            let params= {
                end_date: this.formList.datePick[1],
                mobile: this.formList.phone,
                name: this.formList.name,
                order_id: this.formList.xbedOrder,
                out_order_id: this.formList.elongOrder,
                page_num: this.formList.page,
                page_size: this.formList.pageSize,
                pay_status: this.formList.payStatus,
                start_date: this.formList.datePick[0],
                status: this.formList.orderStatus,
                finish_start_date:this.formList.finishPick[0],
                finish_end_date:this.formList.finishPick[1]
            }
            if(this.formList.payStatus == 99 && this.formList.payStatus != 0){
                delete params['pay_status']
            }
            if(this.formList.orderStatus == 99 && this.formList.orderStatus != 0){
                delete params['status']
            }
            for(let key in params){
                if(!params[key] && parseFloat(params[key]) !== 0){
                    delete params[key]
                }
            }
            return params;
        }
    },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/elong/roomSourceOrderList.vue